import {useEffect, useRef, useState} from 'react';
import {ICellRendererParams} from 'ag-grid-community';
import MenuOptionsPopup, {MenuOptionsPopupProps} from "../../popup/MenuOptionsPopup.tsx";
import dottedLines from "../../../../public/images/more-2-line-3.svg"

export type ViewActionRendererProps = ICellRendererParams & {
    rowOptions: MenuOptionsPopupProps["menuOptions"]
    data: any
}

export function ViewActionRenderer(props: ViewActionRendererProps) {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleOpen = () => {
        setIsOpen(true)
    };
    const handleClose = () => setIsOpen(false);

    useEffect(() => {
        // Force AG Grid to refresh the cell size when the popup opens or closes
        if (props.api && props.column) {
            props.api.refreshCells({
                force: true,
                columns: [props.column],
                rowNodes: [props.node]
            });
        }
    }, [isOpen]);

    return (
        <div ref={containerRef}
             style={{height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <img src={dottedLines} loading="lazy" style={{rotate: "90deg"}}
                 alt="" className="image-27 view-more-icon" onClick={() => {
                // dispatch(modal.mutation.setActiveData(props.data))
                handleOpen()
            }}/>
            <MenuOptionsPopup
                referenceElement={containerRef.current}
                isOpen={isOpen}
                onClose={handleClose}
                menuOptions={props.rowOptions}
                data={props.data}
                // style={{position: 'absolute', zIndex: 1000}}
            />
        </div>
    );
}
